





































import { Component, Prop, Vue } from "vue-property-decorator";
import CircularGauge from "./CircularGauge.vue";
import DashCard from "@/components/app/shared/cards/dash-card.vue";
import { ITelemetryStorage } from "@/@types/servers/telemetry";

@Component({
  components: { CircularGauge, DashCard },
})
export default class StorageCard extends Vue {
  @Prop({ type: Object, required: true }) readonly storage!: ITelemetryStorage;

  get storageColor(): string {
    if (this.storage.usagePercent > 85) return "danger";
    if (this.storage.usagePercent > 70) return "warning";
    return "success";
  }

  get barClass(): string {
    if (this.storage.usagePercent > 85) return "bar-danger";
    if (this.storage.usagePercent > 70) return "bar-warning";
    return "bar-success";
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return "0 B";
    const tb = bytes / (1024 * 1024 * 1024 * 1024);
    if (tb >= 1) return tb.toFixed(2) + " TB";
    const gb = bytes / (1024 * 1024 * 1024);
    return gb.toFixed(1) + " GB";
  }
}
